export default __webpack_public_path__ + "static/media/010-tools-and-utensils-3.9a526c22.png";